<template>
    <button v-bind="$attrs" :type="type" :disabled="disabled" class="w-full flex items-center justify-center gap-2 text-nowrap text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed self-end" :class="ext">
        <font-awesome-icon v-if="icon" :icon="icon" class="text-lg" :class="{ 'animate-spin': withSpin }" />
        {{ buttonText }}
    </button>
</template>

<script>
    export default {
        props: {
            buttonText: {
                type: String,
                default: 'Submit'
            },
            icon: {
                type: Object,
                default: null
            },
            ext: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'submit'
            },
            withSpin: {
                type: Boolean,
                default: false
            },
            iconClass: {
                type: String,
                default: ''
            }
        }
    }

</script>
